import React from "react";

const Loading = () => {
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", height: "100vh", fontFamily: "Poppins, sans-serif",
      gap: 16
    }}>
      <div style={{
        width: 40, height: 40, border: "4px solid #e0e0e0",
        borderTop: "4px solid #cc0000", borderRadius: "50%",
        animation: "spin 0.8s linear infinite"
      }} />
      <p style={{ color: "#666", fontSize: 14 }}>Loading...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default Loading;
